var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('List',{attrs:{"items":_vm.roles,"fields":_vm.fields,"permisos":_vm.permisos}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }